<template>
	<div class="certificate">
		<img class="certificate-banner" src="https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/banner.png" alt="">
		<!-- 师资培训 布局样式 -->


		<div class="train">
			<div class="fanhui" @click="fanhui()">
				返回上一页
			</div>
			<div class="course-title">
				<span style="font-size: 30px;color: #333333;font-weight: bold;">课程内容</span><br />
				<span style="font-size: 16px;color: #999999;">COURSE CONTENT</span>
			</div>
			<!-- 师资培训-课程内容-列表 -->
			<div class="down-list">
				<div v-for="(item,index) in titleList" :key="index" class="down-item">
					<div class="down-item-left"><img src="../../assets/1+X/ppt.png" />{{item.name}}</div>
					<div v-if="item.attachment!=''" class="down-item-right"><a :href="item.attachment">
							<p>Download</p>
						</a></div>
					<div v-else class="down-item-right"><a>
							<p>Download</p>
						</a></div>
				</div>
			</div>
			<!-- 师资培训-课程内容-分页 -->
			<div class="title-page" style="padding: 0;margin: 60px 0 50px 0;">
				<div class="flex">
					<div class="box active">1</div>
				</div>
				<div class="box title-page-active" style="width: 150px;">下一页</div>
			</div>
		</div>
	</div>

</template>

<script>
	//禁止此页的右键事件
	document.oncontextmenu = function() {
		return false;
	};

	export default {
		components: {},
		data() {
			return {
				mouseFlag: false,
				jiantouFlag: true,
				index: 0,
				videoIndex: 0, //video-mini-list开始下标
				playIndex: 0, //video-main所显示播放列表中的视频内容
				videoFlag: true, //控制ideo-main的播放图标 true显示 false不显示
				/**
				 * img:视频列表显示的图片
				 * video:主播放窗口的视频链接
				 * title:视频列表及主播放窗口下显示的文字
				 * 
				 * 后台没有相关模块  更新需要修改页面数据
				 */
				
				titleList: [{
						"name": "1.1+X证书制度书证融通解读-杨建华",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/1.1%2BX证书制度书证融通解读-杨建华.pdf",
						"attachment_name": "1.1+X证书制度书证融通解读-杨建华",
					},
					{
						"name": "2.1+X证书制度学习交流-杨建华",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/2.1%2BX证书制度学习交流-杨建华.pdf",
						"attachment_name": "2.1+X证书制度学习交流-杨建华",
					},
					{
						"name": "3.垃圾焚烧锅炉设备及运行-杨宏民",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/3.垃圾焚烧锅炉设备及运行-杨宏民.pdf",
						"attachment_name": "3.垃圾焚烧锅炉设备及运行-杨宏民",
					},
					{
						"name": "4.垃圾焚烧锅炉运行调整-杨宏民",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/4.垃圾焚烧锅炉运行调整-杨宏民.pdf",
						"attachment_name": "4.垃圾焚烧锅炉运行调整-杨宏民",
					},
					{
						"name": "5.垃圾焚烧锅炉运行与维护培训-王玉召",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/5.垃圾焚烧锅炉运行与维护培训-王玉召.pdf",
						"attachment_name": "5.垃圾焚烧锅炉运行与维护培训-王玉召",
					},
					{
						"name": "6.垃圾焚烧机组主要系统构成及功能介绍-王永刚",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/6.垃圾焚烧机组主要系统构成及功能介绍-王永刚.pdf",
						"attachment_name": "6.垃圾焚烧机组主要系统构成及功能介绍-王永刚",
					},
					{
						"name": "7.垃圾焚烧机组运行汽轮机设备及系统-曾国兵",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/7.垃圾焚烧机组运行汽轮机设备及系统-曾国兵.pdf",
						"attachment_name": "7.垃圾焚烧机组运行汽轮机设备及系统-曾国兵",
					},
					{
						"name": "8.电气基础-李春林",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/8.电气基础-李春林.pdf",
						"attachment_name": "8.电气基础-李春林",
					},
					{
						"name": "9.垃圾焚烧机组电气系统培训-李春林",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/9.垃圾焚烧机组电气系统培训-李春林.pdf",
						"attachment_name": "9.垃圾焚烧机组电气系统培训-李春林",
					}
				]
			};
		},
		watch: {},
		created() {},
		mounted() {
			this.index = localStorage.getItem('index');
			//console.log(this.index);
			//在mounted()方法里监听mousewheel；
			// chrome and ie
			window.addEventListener('mousewheel', this.handleScroll, false)
			//// firefox
			window.addEventListener("DOMMouseScroll", this.handleScroll, false)
		},
		methods: {
			//师资培训-右侧视频列表下滑动
			arrowDown() {
				if (this.videoList.length - this.videoIndex > 4) {
					this.videoIndex = this.videoIndex + 1;
				}
			},
			//师资培训-右侧视频列表上滑动
			arrowUp() {
				if (this.videoIndex > 0) {
					this.videoIndex = this.videoIndex - 1;
				}
			},
			//师资培训-右侧视频列表点击播放事件
			change(n) {
				if (n != this.playIndex) {
					this.playIndex = n;
					this.videoFlag = true;
				}
			},
			//控制播放器播放，取消播放按钮样式
			videoPlay() {
				var video = document.getElementById('movie');
				video.play();
				this.videoFlag = false;
			},
			suojin() {
				if (this.jiantouFlag) {
					this.jiantouFlag = false;
				} else {
					this.jiantouFlag = true;
				}
			},
			fanhui() {
				this.$router.go(-1); //返回上一层
			},
			handleScroll(e) {
				//console.log("滑动了。。。")
				var direction = e.deltaY > 0 ? 'down' : 'up' //该语句可以用来判断滚轮是向上滑动还是向下
				if (document.getElementsByTagName("li").length == 1) { //此处决定无论一次滚轮滚动的距离是多少，此事件                                                              
					//都得等上次滚动结束，才会执行本次
					this.isShow = false
					setTimeout(() => {
						this.isShow = true
							++this.nowIndex
						if (this.nowIndex == 3) {
							this.nowIndex = 0
						}
					}, 10)
				}
			},
			wheel() {
				//console.log("vue滚动。。。")
			}

		}
	};
</script>

<style scoped>
	.certificate {
		position: relative;
	}

	.certificate-banner {
		width: 100%;
		height: 450px;
	}

	.train {
		width: 1200px;
		margin: 0 auto;
	}

	.w-video {
		background-color: #EDEDED;
		padding-bottom: 40px;
	}

	.video {
		/* border-radius:10px;
		-moz-box-shadow:0 0 8px #c2c2c2;
		-webkit-box-shadow:0 0 8px #c2c2c2;
		box-shadow:0 0 8px #c2c2c2; */
		padding: 50px;
		display: flex;
		justify-content: space-between;
		margin: auto auto;
		width: 946px;
		height: 532px;
	}

	.video-title,
	.course-title {
		/* padding-top: 30px; */
		margin-top: 60px;
		margin-bottom: 40px;
		text-align: center;
	}

	.video-title {
		margin-top: 0;
		margin-bottom: 10px;
	}

	.video-show {
		height: 92px;
		width: 92px;
		margin: -265px 0 0 427px;
		position: relative;
		z-index: 3;
		display: block;
	}

	.video-hidden {
		height: 92px;
		width: 92px;
		margin: -313.5px 0 0 427px;
		position: relative;
		z-index: 3;
		display: none;
	}

	.video-main {
		height: 532px;
		width: 946px;
		background-color: #999999;
	}

	.video-main-title {
		font-size: 24px;
		color: #FFFFFF;
		position: relative;
		z-index: 2;
		margin-top: -95px;
		margin-left: 20px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.bofang1:hover {
		cursor: pointer;
	}

	.video-mini {
		width: 225px;
		height: 532px;
		position: relative;
		margin-top: -412px;
		margin-left: 721px;
	}

	.video-mini ul {
		overflow: hidden;
		width: 225px;
		height: 532px;
	}

	.video-mini li {
		height: 126px;
		width: 225px;
		background: #999999;
		position: relative;
		cursor: pointer;
		margin-bottom: 10px;
	}

	.video-mini-title {
		display: inline-block;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		max-width: 200px;
		letter-spacing: 1px;
		font-size: 14px;
		color: #FFFFFF;
		z-index: 3;
		position: absolute;
		margin-top: -22px;
		margin-left: 6px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.video-mini-title1 {
		display: inline-block;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		max-width: 200px;
		letter-spacing: 1px;
		font-size: 14px;
		color: #f25b20;
		z-index: 3;
		position: absolute;
		margin-top: -22px;
		margin-left: 6px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.video-mini-img {
		display: inline-block;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		max-width: 200px;
		letter-spacing: 1px;
		font-size: 14px;
		z-index: 3;
		position: absolute;
		margin-top: -76px;
		margin-left: 102px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.arrow-up {
		position: absolute;
		width: 225px;
		height: 25px;
		background: #FFFAFA;
		margin-top: -565px;
		text-align: center;
		cursor: pointer;
	}

	.arrow-down {
		width: 225px;
		height: 25px;
		background: #FFFAFA;
		position: absolute;
		margin-top: 6px;
		text-align: center;
		cursor: pointer;
	}

	.jiantou {
		position: relative;
		margin-left: 696px;
		margin-top: 80px;
	}

	.jiantou1 {
		position: relative;
		margin-left: 920px;
		margin-top: 80px;
	}

	.jiantou:hover {
		cursor: pointer;
	}

	.jiantou1:hover {
		cursor: pointer;
	}

	.revolve {
		-moz-transform: rotate(90deg);
		-webkit-transform: rotate(90deg);
		display: block;
		color: #2d73d9;
		font-size: 20px;
		width: 25px;
		margin: auto;
	}

	.title-page {
		display: flex;
		justify-content: space-between;
		width: auto;
		padding: 0px 20px 0px 75px;
		margin: 90px 0px 70px;
	}

	.title-page .box {
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		margin-right: 2px;
		font-size: 16px;
		color: #333;
		background: #ddd;
	}

	.box:hover {
		cursor: pointer;
	}

	.title-page .flex {
		display: flex;
	}

	.title-page .active {
		color: #fff;
		background: #0055d3;
	}

	.title-page-active:active {
		background: #0055d3;
		color: #fff;
	}

	/* .down-list {
		min-height: 350px;
	} */

	.down-item {
		height: 80px;
		font-size: 16px;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px #CCCCCC solid;
		line-height: 80px;
	}

	.icon {
		width: 26px;
		height: 26px;
	}

	.down-item-left {
		color: #333333;
		margin-left: 20px;
	}

	.down-item-left img {
		margin-top: -4px;
		vertical-align: middle;
		display: inline-block;
		margin-right: 20px;
	}

	.down-item-right {
		margin: auto 0;
		margin-right: 20px;
	}

	.down-item-right p {
		width: 136px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		border: 2px solid #0055d3;
		border-radius: 30px;
		background: #fff;
		cursor: pointer;
	}

	.down-item-right p:hover {
		background: #0055d3;
		color: #fff;
	}

	.fanhui {
		display: inline-block;
		color: #606266;
		background: #fff;
		border: 1px solid #dcdfe6;
		padding: 10px 12px;
		position: absolute;
	}

	.fanhui:hover {
		color: #528CE0;
		cursor: pointer;
		border: 1px solid #DAE6FF;
	}
</style>
